( function ( $ ) {
	'use strict';

	const $html = $( 'html' );

	$( '.site-header__toggle' ).on( 'click', function () {
		$html.toggleClass( 'nav-open' );
	} );

	/* eslint-disable */
	function toggleAccordion( accordionItem ) {
		if (!accordionItem.hasClass('menu-item--active')) {
			$('.menu-item-has-children').removeClass( 'menu-item--active' );
			$('.menu-item-has-children').find('.sub-menu').slideUp(200);
			accordionItem.toggleClass( 'menu-item--active' );
			setTimeout(function() {
				accordionItem.find('.sub-menu').slideDown(300);
			}, 250);
		}
	}

	function handleAccordionClick() {
		const accordionItem = $( this );
		const isMobile = window.matchMedia( '(max-width: 768px)' ).matches; // Check if it's mobile

		toggleAccordion( accordionItem );
	}

	$( '.site-header .menu-item-has-children' ).on( 'click', handleAccordionClick );
	/* eslint-enable */

} )( jQuery );
